import React, { useState, useEffect } from "react";
import './imageGalllery.css';

import Rectangle393 from "../assets/Rectangle 393.png";
import Rectangle389 from "../assets/Rectangle 389.png";
import Rectangle388 from "../assets/Rectangle 388.png";
import Rectangle390 from "../assets/Rectangle 390.png";

const ImageGallery = () => {
  const [images, setImages] = useState({
    image1: Rectangle393,
    image2: Rectangle389,
    image3: Rectangle388,
    image4: Rectangle390,
    nameofplace: 'Dubai'
  });

  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch("https://api.com/images");
        if (!response.ok) {
          throw new Error("Failed to fetch images");
        }
        const data = await response.json();

        setImages({
          image1: data.image1 || Rectangle393,
          image2: data.image2 || Rectangle389,
          image3: data.image3 || Rectangle388,
          image4: data.image4 || Rectangle390,
          nameofplace: data.name || 'Dubai'
        });
      } catch (error) {
        console.error("Error fetching images:", error);
        setError(true);
      }
    };

    fetchImages();
  }, []);

  return (
    <div className="ImageGallery">
      <div className="image1">
        <div style={{ width: '100%' }}>
          <img style={{ width: '100%' }} alt="image 1" src={images.image1} />
        </div>
        <div className="cityname">{images.nameofplace}</div>
      </div>
      <div className="image23row">
        <div style={{ width: '100%' }}>
          <img style={{ width: '100%' }} alt="image 2" src={images.image2} />
        </div>
        <div style={{ width: '100%' }}>
          <img style={{ width: '100%' }} alt="image 3" src={images.image3} />
        </div>
      </div>
      <div className="image4">
        <div>
          <img style={{ width: '100%' }} alt="image 4" src={images.image4} />
        </div>
      </div>
    </div>
  );
};

export default ImageGallery;
